import React from "react";

const Carousel = () => {
  return (
    <div className="carousel w-full">
      <div
        id="slide1"
        className="carousel-item relative w-full h-[400px] object-cover bg-gray-50"
      >
        {/* <div className="flex items-center px-20 gap-10">
          <video
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F70303-makeup-beauty.mp4?alt=media&token=f13d6ff0-f3bf-4c0e-8ab2-a09383d91b37"
            autoPlay={true}
            loop
            className="mx-auto w-96"
          ></video>
          <div className="">
            <h1 className="text-3xl">About Us</h1>
            <button className="btn btn-pink px-10 btn-sm">click</button>
          </div>
        </div> */}
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FPC_banner02%20(1).png?alt=media&token=be67f90b-3b69-49fa-8ba1-ba2a2914e506"
          className="w-full object-fill"
        />
        <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide2" className="btn btn-circle">
            ❮
          </a>
          <a href="#slide2" className="btn btn-circle">
            ❯
          </a>
        </div>
      </div>
      <div
        id="slide2"
        className="carousel-item relative w-full h-[400px] object-cover"
      >
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FHomepage_banner01%20(1).png?alt=media&token=95453035-ede1-491b-9998-f0a6aa09801c"
          className="w-full object-cover"
        />
        <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide1" className="btn btn-circle">
            ❮
          </a>
          <a href="#slide1" className="btn btn-circle">
            ❯
          </a>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
